// Function to change the theme
function changeTheme(theme) {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  } else if (theme === 'light') {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  } else {
    // If theme is not 'light' or 'dark', respect OS-level preference
    const currentTheme = document.documentElement.classList.toggle('dark', window.matchMedia('(prefers-color-scheme: dark)').matches);
    localStorage.setItem('theme', currentTheme ? 'dark' : 'light');
  }
}

// Function to toggle the theme based on the current setting
function toggleTheme() {
  const currentTheme = localStorage.getItem('theme');
  if (currentTheme === 'dark') {
    changeTheme('light');
  } else {
    changeTheme('dark');
  }
  updateToggleButton();
}

// Update the toggle button text based on the current theme
function updateToggleButton() {
  const themeToggleButton = document.getElementById('themeToggleButton');
  if (themeToggleButton) {
    themeToggleButton.textContent = document.documentElement.classList.contains('dark') ? 'Light Mode' : 'Dark Mode';
  }
}

// Event listeners and initial theme setting
document.addEventListener('DOMContentLoaded', () => {
  // Set the initial theme based on the localStorage or OS preference
  changeTheme(localStorage.getItem('theme'));

  // Update the button text when the page loads
  updateToggleButton();

  // Attach event listener to the toggle button
  const themeToggleButton = document.getElementById('themeToggleButton');
  if (themeToggleButton) {
    themeToggleButton.addEventListener('click', toggleTheme);
  }
});
